import { Icon } from 'components/Icon';
import { Closeable } from 'components/util/Closeable';
import { classNames, React, useState } from 'libs/react';
import './ActivityMenu.scss';
/**
 * @component ActivityMenu
 * @since 1.0.0
 * "…" menu of a note or reminder. Anchored to the right edge so it stays
 * inside narrow panels like the deal sidebar.
 */
export function ActivityMenu(props) {
    const { items, onSelect } = props;
    const [open, setOpen] = useState(false);
    /**
     * @function select
     * @since 1.0.0
     */
    function select(value) {
        setOpen(false);
        onSelect(value);
    }
    return (React.createElement(Closeable, { onClose: () => setOpen(false) },
        React.createElement("div", { className: classNames('activity-menu', props.className, {
                'activity-menu--open': open
            }) },
            React.createElement("button", { type: "button", className: "activity-menu-trigger", "aria-label": t('Actions'), "aria-haspopup": "menu", "aria-expanded": open, onClick: () => setOpen(!open) },
                React.createElement(Icon, { value: "far ellipsis" })),
            open && (React.createElement("ul", { className: "activity-menu-list", role: "menu" }, items.map((item, index) => item.value ? (React.createElement("li", { key: item.value, role: "none" },
                React.createElement("button", { type: "button", role: "menuitem", className: classNames('activity-menu-item', {
                        'activity-menu-item--danger': item.danger
                    }), onClick: () => select(item.value) },
                    item.picto && (React.createElement(Icon, { className: "activity-menu-item-picto", value: item.picto })),
                    React.createElement("span", { className: "activity-menu-item-label" }, item.label),
                    item.hint && (React.createElement("span", { className: "activity-menu-item-hint" }, item.hint))))) : (React.createElement("li", { key: 'section-' + index, role: "presentation", className: "activity-menu-section" }, item.label))))))));
}
